import { Routes } from '@angular/router';

import { ROUTE_PATH } from '@shared/enum/common.enum';
import { authGuard } from '@shared/guard/auth.guard';
import { PermissionGuard } from '@shared/guard/permission.guard';

export const dashboardRoutes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('@app/layout/app.layout.component').then(
                (m) => m.AppLayoutComponent
            ),
        canActivate: [authGuard],
        children: [
            {
                path: ROUTE_PATH.PROFILE,
                loadComponent: () =>
                    import(
                        '@app/components/members/upsert-user/upsert-user.component'
                    ).then((m) => m.UpsertUserComponent),
            },
            {
                path: ROUTE_PATH.MEMBERS,
                loadComponent: () =>
                    import('@components/members/members.component').then(
                        (m) => m.MembersComponent
                    ),
                canActivate: [PermissionGuard],
            },
            {
                path: ROUTE_PATH.ROLE,
                loadComponent: () =>
                    import(
                        '@app/components/role-list/role-list.component'
                    ).then((m) => m.RoleListComponent),
                canActivate: [PermissionGuard],
            },
            {
                path: ROUTE_PATH.ADD_ROLE,
                loadComponent: () =>
                    import(
                        '@app/components/role-list/add-edit-role/add-edit-role.component'
                    ).then((m) => m.AddEditRoleComponent),
                canActivate: [PermissionGuard],
            },
            {
                path: `${ROUTE_PATH.EDIT_ROLE}/:id`,
                loadComponent: () =>
                    import(
                        '@app/components/role-list/add-edit-role/add-edit-role.component'
                    ).then((m) => m.AddEditRoleComponent),
                canActivate: [PermissionGuard],
            },
            {
                path: ROUTE_PATH.ADD_MEMBER,
                loadComponent: () =>
                    import(
                        '@app/components/members/upsert-user/upsert-user.component'
                    ).then((m) => m.UpsertUserComponent),
                canActivate: [PermissionGuard],
            },
            {
                path: `${ROUTE_PATH.EDIT_MEMBER}/:id`,
                loadComponent: () =>
                    import(
                        '@app/components/members/upsert-user/upsert-user.component'
                    ).then((m) => m.UpsertUserComponent),
                canActivate: [PermissionGuard],
            },

            {
                path: ROUTE_PATH.TEAM_MANAGEMENT,
                loadComponent: () =>
                    import('@app/components/team/team.component').then(
                        (m) => m.TeamComponent
                    ),
                canActivate: [PermissionGuard],
            },
            {
                path: ROUTE_PATH.HOME,
                loadComponent: () =>
                    import(
                        '@app/components/program/program-catalogue/program-catalogue.component'
                    ).then((m) => m.ProgramCatalogueComponent),
                canActivate: [PermissionGuard],
            },
            {
                path: ROUTE_PATH.ADD_PROGRAM_CATALOGUE,
                loadComponent: () =>
                    import(
                        '@app/components/program/create-program/create-program.component'
                    ).then((m) => m.CreateProgramComponent),
                canActivate: [PermissionGuard],
            },
            {
                path: `${ROUTE_PATH.EDIT_PROGRAM_CATALOGUE}/:id`,
                loadComponent: () =>
                    import(
                        '@app/components/program/create-program/create-program.component'
                    ).then((m) => m.CreateProgramComponent),
                canActivate: [PermissionGuard],
            },
            {
                path: ROUTE_PATH.OVERVIEW,
                loadComponent: () =>
                    import('@app/components/overview/overview.component').then(
                        (m) => m.OverviewComponent
                    ),
                canActivate: [PermissionGuard],
            },
            {
                path: `${ROUTE_PATH.OVERVIEW}/:id`,
                loadComponent: () =>
                    import('@app/components/overview/overview.component').then(
                        (m) => m.OverviewComponent
                    ),
                canActivate: [PermissionGuard],
            },
            {
                path: `${ROUTE_PATH.PROGRAM}/:id`,
                loadComponent: () =>
                    import(
                        '../../shared/component/main-layout/inner-layout.component'
                    ).then((m) => m.InnerLayoutComponent),

                children: [
                    {
                        path: ROUTE_PATH.FUNDAMENTAL,
                        loadComponent: () =>
                            import(
                                '@app/components/program/fundamental/fundamental.component'
                            ).then((m) => m.FundamentalComponent),
                        data: { pageHeading: 'Fundamentals' },
                        canActivate: [PermissionGuard],
                    },
                    {
                        path: ROUTE_PATH.KNOWLEDGE_GOALS,
                        loadComponent: () =>
                            import(
                                '@app/shared/component/configure-program-form/configure-program-form.component'
                            ).then((m) => m.ConfigureProgramFormComponent),
                        data: { pageHeading: 'Knowledge Goals' },
                        canActivate: [PermissionGuard],
                    },
                    {
                        path: ROUTE_PATH.TARGET_AUDIENCE,
                        loadComponent: () =>
                            import(
                                '@app/shared/component/configure-program-form/configure-program-form.component'
                            ).then((m) => m.ConfigureProgramFormComponent),
                        data: { pageHeading: 'Target Audience' },
                        canActivate: [PermissionGuard],
                    },
                    {
                        path: ROUTE_PATH.PRE_REQUISITES,
                        loadComponent: () =>
                            import(
                                '@app/shared/component/configure-program-form/configure-program-form.component'
                            ).then((m) => m.ConfigureProgramFormComponent),
                        data: { pageHeading: 'Prerequisite' },
                        canActivate: [PermissionGuard],
                    },
                    {
                        path: ROUTE_PATH.TRAINING_OBJECTIVES,
                        loadComponent: () =>
                            import(
                                '@app/shared/component/configure-program-form/configure-program-form.component'
                            ).then((m) => m.ConfigureProgramFormComponent),
                        data: { pageHeading: 'Training Objectives' },
                        canActivate: [PermissionGuard],
                    },
                    {
                        path: ROUTE_PATH.CONTENT_DESCRIPTION,
                        loadComponent: () =>
                            import(
                                '@app/shared/component/configure-program-form/configure-program-form.component'
                            ).then((m) => m.ConfigureProgramFormComponent),
                        data: { pageHeading: 'Content Description' },
                        canActivate: [PermissionGuard],
                    },
                    {
                        path: ROUTE_PATH.USE_CASES,
                        loadComponent: () =>
                            import(
                                '@app/shared/component/configure-program-form/configure-program-form.component'
                            ).then((m) => m.ConfigureProgramFormComponent),
                        data: { pageHeading: 'Use Cases' },
                        canActivate: [PermissionGuard],
                    },
                    {
                        path: ROUTE_PATH.EKC_MATRIX,
                        loadComponent: () =>
                            import(
                                '@app/shared/component/configure-program-form/configure-program-form.component'
                            ).then((m) => m.ConfigureProgramFormComponent),
                        data: { pageHeading: 'EKC Matrix' },
                        canActivate: [PermissionGuard],
                    },
                    {
                        path: ROUTE_PATH.COURSE,
                        loadComponent: () =>
                            import(
                                '@app/shared/component/configure-program-form/configure-program-form.component'
                            ).then((m) => m.ConfigureProgramFormComponent),
                        data: { pageHeading: 'Course outline' },
                        canActivate: [PermissionGuard],
                    },
                    {
                        path: `${ROUTE_PATH.COURSE}/:id/${ROUTE_PATH.LESSON}`,
                        loadComponent: () =>
                            import(
                                '@app/shared/component/configure-program-form/configure-program-form.component'
                            ).then((m) => m.ConfigureProgramFormComponent),
                        data: { pageHeading: 'Lesson' },
                        canActivate: [PermissionGuard],
                    },
                    {
                        path: `${ROUTE_PATH.COURSE}/:id/${ROUTE_PATH.LESSON}/:lessonId/${ROUTE_PATH.EDIT}`,
                        loadComponent: () =>
                            import(
                                '@app/shared/component/configure-program-form/configure-program-form.component'
                            ).then((m) => m.ConfigureProgramFormComponent),
                        data: { pageHeading: 'Edit Lesson' },
                        canActivate: [PermissionGuard],
                    },
                    {
                        path: `${ROUTE_PATH.COURSE}/:id/${ROUTE_PATH.LESSON}/:lessonId/${ROUTE_PATH.CHAPTER}/:chapterId/${ROUTE_PATH.EDIT}`,
                        loadComponent: () =>
                            import(
                                '@app/shared/component/configure-program-form/configure-program-form.component'
                            ).then((m) => m.ConfigureProgramFormComponent),
                        data: { pageHeading: 'Edit Chapter' },
                        canActivate: [PermissionGuard],
                    },
                    {
                        path: `${ROUTE_PATH.COURSE}/:id/${ROUTE_PATH.LESSON}/:lessonId/${ROUTE_PATH.CHAPTER}`,
                        loadComponent: () =>
                            import(
                                '@app/shared/component/configure-program-form/configure-program-form.component'
                            ).then((m) => m.ConfigureProgramFormComponent),
                        data: { pageHeading: 'Chapter' },
                        canActivate: [PermissionGuard],
                    },
                    {
                        path: `${ROUTE_PATH.COURSE}/:id/${ROUTE_PATH.LESSON}/:lessonId/${ROUTE_PATH.CHAPTER}/:chapterId/${ROUTE_PATH.SECTION}`,
                        loadComponent: () =>
                            import(
                                '@app/shared/component/configure-program-form/configure-program-form.component'
                            ).then((m) => m.ConfigureProgramFormComponent),
                        data: { pageHeading: 'Section' },
                        canActivate: [PermissionGuard],
                    },
                    {
                        path: `${ROUTE_PATH.COURSE}/:id/${ROUTE_PATH.LESSON}/:lessonId/${ROUTE_PATH.CHAPTER}/:chapterId/${ROUTE_PATH.SECTION}/:sectionId/${ROUTE_PATH.EDIT}`,
                        loadComponent: () =>
                            import(
                                '@app/shared/component/configure-program-form/configure-program-form.component'
                            ).then((m) => m.ConfigureProgramFormComponent),
                        data: { pageHeading: 'Edit Section' },
                        canActivate: [PermissionGuard],
                    },
                    {
                        path: `${ROUTE_PATH.COURSE}/:id/${ROUTE_PATH.LESSON}/:lessonId/${ROUTE_PATH.CHAPTER}/:chapterId/${ROUTE_PATH.SECTION_TAB}`,
                        loadComponent: () =>
                            import(
                                '@app/components/program/section-tab/section-tab.component'
                            ).then((m) => m.SectionTabComponent),
                        data: { pageHeading: 'Section' },
                        canActivate: [PermissionGuard],
                    },

                    {
                        path: `${ROUTE_PATH.COURSE}/:id/${ROUTE_PATH.EDIT}`,
                        loadComponent: () =>
                            import(
                                '@app/shared/component/configure-program-form/configure-program-form.component'
                            ).then((m) => m.ConfigureProgramFormComponent),
                        data: { pageHeading: 'Edit Course' },
                        canActivate: [PermissionGuard],
                    },
                ],
            },
            {
                path: ROUTE_PATH.KNOWLEDGE_BANK,
                loadComponent: () =>
                    import(
                        '@app/components/knowledgebank/knowledgebank.component'
                    ).then((m) => m.KnowledgebankComponent),
                canActivate: [PermissionGuard],
            },
            {
                path: `${ROUTE_PATH.PRODUCTION_DASHBOARD}/:id`,
                loadComponent: () =>
                    import(
                        '@app/components/production-dashboard/production-dashboard.component'
                    ).then((m) => m.ProductionDashboardComponent),
                canActivate: [PermissionGuard],
            },
            {
                path: ROUTE_PATH.PRODUCTION_DASHBOARD,
                loadComponent: () =>
                    import(
                        '@app/components/production-dashboard/production-dashboard.component'
                    ).then((m) => m.ProductionDashboardComponent),
                canActivate: [PermissionGuard],
            },
        ],
    },
];
// Note: While adding a route, don't forget to maintain route in `permission.model.ts`;
